import React from 'react';
import { Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import IWall from 'components/interfaces/IWall';
import translations from 'services/translations/translations';
import SelectInputFieldControlled from 'components/layout/forms/SelectInputFieldControlled';
import NumberInputField from 'components/layout/forms/NumberInputField';
import TextInputField from 'components/layout/forms/TextInputField';

import {
  glazyDoubleWidthOptions,
  glazyDoubleGlassOptions,
  postionOnWallOptions,
} from 'components/configurator/types/doorOptions';

import handleGlassWallProperties from './handleGlassWallProperties';
import { setWall } from '../../../../../store/selectedWall/actions';

const GlazyDoubleProperties = ({
  wall,
  disableInputs,
}: {
  wall: IWall;
  disableInputs?: boolean;
}) => {
  const { t } = useTranslation([translations.glassWallDoorProperties]);
  const editFieldsClassName = 'edit-fields';
  const dispatch = useDispatch();

  const handeGlazyDoubleWidthChange = (event: any) => {
    dispatch(
      setWall({
        ...wall,
        glazyDoubleWidth: parseInt(event.target.value, 10),
      })
    );
  };

  return (
    <div>
      {wall.glazingWallType.includes('glazydouble') ? (
        <div>
          <Row>
            <Col>
              <h5>
                {t(
                  `${translations.glassWallDoorProperties}:doorHeaderTitles:glazzyDoubleParameters`
                )}
              </h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <SelectInputFieldControlled
                id="glazyDoubleWidth"
                label={t(
                  `${translations.glassWallDoorProperties}:fields:Glazy Double Width`
                )}
                name="glazyDoubleWidth"
                onChange={handeGlazyDoubleWidthChange}
                options={glazyDoubleWidthOptions()}
                required
                value={wall.glazyDoubleWidth}
                disabled={disableInputs}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <SelectInputFieldControlled
                id="glazyDoubleGlassType"
                label={t(
                  `${translations.glassWallDoorProperties}:fields:Glazy Double Special Test`
                )}
                name="glazyDoubleGlassType"
                onChange={handleGlassWallProperties}
                options={glazyDoubleGlassOptions()}
                required
                value={wall.glazyDoubleGlassType}
                disabled={disableInputs}
              />
            </Col>
            <Col>
              <SelectInputFieldControlled
                id="glazyDoubleSpecialPos"
                label={t(
                  `${translations.glassWallDoorProperties}:fields:Position On Wall`
                )}
                name="glazyDoubleSpecialPos"
                onChange={handleGlassWallProperties}
                options={postionOnWallOptions()}
                required
                value={wall.glazyDoubleSpecialPos}
                disabled={disableInputs}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <NumberInputField
                id="glazyDoubleSpecialHeight"
                label={t(
                  `${translations.glassWallDoorProperties}:fields:DoorHeight`
                )}
                onChange={handleGlassWallProperties}
                value={wall.glazyDoubleSpecialHeight}
                name="glazyDoubleSpecialHeight"
                required
                disabled={disableInputs}
              />
            </Col>
            <Col>
              <TextInputField
                id="glazyDoubleSpecialColor"
                label={t(
                  `${translations.glassWallDoorProperties}:fields:Color`
                )}
                onChange={handleGlassWallProperties}
                value={wall.glazyDoubleSpecialColor}
                name="glazyDoubleSpecialColor"
                required
                className={editFieldsClassName}
                disabled={disableInputs}
              />
            </Col>
          </Row>
        </div>
      ) : null}
    </div>
  );
};

export default GlazyDoubleProperties;
